module.exports = __webpack_public_path__ + "static/media/sass.50c1d1bc.svg";